import { render, staticRenderFns } from "./Chunk.vue?vue&type=template&id=38ffac46&scoped=true&"
import script from "./Chunk.vue?vue&type=script&lang=js&"
export * from "./Chunk.vue?vue&type=script&lang=js&"
import style0 from "./Chunk.vue?vue&type=style&index=0&id=38ffac46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ffac46",
  null
  
)

export default component.exports